// 定位div(contenteditable = "true")；超过字数光标定位到末端
export function po_Last_Div(obj) {
  if (window.getSelection) {
    //ie11 10 9 ff safari
    obj.focus() //解决ff不获取焦点无法定位问题
    let range = window.getSelection() //创建range
    range.selectAllChildren(obj) //range 选择obj下所有子内容
    range.collapseToEnd() //光标移至最后
  } else if (document.selection) {
    //ie10 9 8 7 6 5
    let range = document.selection.createRange() //创建选择对象
    //var range = document.body.createTextRange();
    range.moveToElementText(obj) //range定位到obj
    range.collapse(false) //光标移至最后
    range.select()
  }
}
// 判断对象所有属性都为''
export function allEmptyKey(obj) {
  let flag = true
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] !== '') {
        flag = false
      }
    }
  }
  return flag
}
// 事件防抖
export function debounce(fn, delay = 500) {
  // timer 是闭包中的
  let timer = null

  return function() {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments)
      timer = null
    }, delay)
  }
}
